import { render, staticRenderFns } from "./AccountAlertUsage.vue?vue&type=template&id=7ecbeed6&scoped=true&"
import script from "./AccountAlertUsage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AccountAlertUsage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AccountAlertUsage.vue?vue&type=style&index=0&id=7ecbeed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecbeed6",
  null
  
)

export default component.exports